import type { Folder } from "../../features/workspace/sidebar/SideBarTypes";
import type { Snippet } from "../../features/workspace/snippets/SnippetContainer";
import type { FileRef } from "../../features/workspace/WorkspaceContext";
import { getSnippetExtension } from "./getFileIconAndExtensionHelper";
import { findFolderInTree } from "./folderTree";

export const NAME_TAKEN_MESSAGE = "This filename already exists";

// Client-side mirror of the server's findNameCollisionInDirectory (server/src/controllers/FolderHelper.ts) —
// used for instant "already taken" feedback while typing, before a request ever reaches the server.
// The server check still runs on submit and stays authoritative.
export function isNameTakenInDirectory(params: {
    folderParent: string | null;
    effectiveName: string;
    excludeResourceId?: string;
    folders: Folder[];
    snippets: Snippet[];
    files: FileRef[];
}): boolean {
    const target = params.effectiveName.trim().toLowerCase();
    if (!target) return false;

    const siblingFolders = params.folderParent
        ? (findFolderInTree(params.folders, params.folderParent)?.folders ?? [])
        : params.folders;

    if (siblingFolders.some(f => f._id !== params.excludeResourceId && f.fname.trim().toLowerCase() === target)) {
        return true;
    }

    const siblingSnippets = params.snippets.filter(s => (s.folderParent ?? null) === params.folderParent);
    if (siblingSnippets.some(s =>
        s._id !== params.excludeResourceId &&
        `${s.snippetName}.${getSnippetExtension(s.snippetLanguage || "txt")}`.trim().toLowerCase() === target
    )) {
        return true;
    }

    const siblingFiles = params.files.filter(f => (f.folderParent ?? null) === params.folderParent);
    if (siblingFiles.some(f => f._id !== params.excludeResourceId && f.name.trim().toLowerCase() === target)) {
        return true;
    }

    return false;
}
